/**
 * ランキング関連の情報
 */
var Ranking = Ranking || {};

/**
 * 商品ランキング情報を返却
 *
 * @param  int|string cityCode
 * @return Deferred
 */
Ranking.get = function(cityCode) {
	var defer = $.Deferred();
	var ajax = $.ajax({
		url: '/service/ranking.json',
		method: 'GET',
		data: {
			cityCode: cityCode,
		},
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};
